import classes from './Posts.module.css'
import React, { useState, useEffect } from 'react'
import { db } from '../firebaseConfig'
import Post from './Post'


function Posts({ collection }) {
    const [post, setPost] = useState([])
    useEffect(() => {
        db.collection(collection).orderBy('createdAt', 'desc').onSnapshot(
            (snap) => {
                let documents = [];
                snap.forEach(doc => {
                    documents.push({ ...doc.data(), id: doc.id })
                })
                setPost(documents);
            }
        )


    }, [collection])
    return (
        <div className={classes.posts}>
            {post && post.map((post) => (
                <div className={classes.postdiv} key={post.id}>
                    <Post {...post} />
                </div>

            ))}

        </div>
    )
}

export default Posts
